/** Query key factory for entity images (see docs/data-layer.md). */
export const entityImageKeys = {
  all: ["entityImages"] as const,
  forEntity: (entityType: string, entityId: string) =>
    ["entityImages", entityType, entityId] as const,
  primaries: (entityType: string, entityIds: string[]) =>
    ["entityImages", "primaries", entityType, entityIds] as const,
};
